<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if="!isLoading")
            game-header(
                :time="getTime"
                @soundStateChanged="headerKey = !headerKey"
                :key="headerKey"
                :slug="type"
                :game-type="parameters && parameters.courseType",
                :is-homework="!!exerciseId"
            )
            game-preparation-counter(v-if='!gameStarted && !gameFinished && counter' :counter="counter")
            template(v-else)
                .catch-word__container(:class="{'catch-word__container_with-content-at-top': !isGameTuned}")
                    scaling-bar(
                        v-if="!isGameTuned"
                        @doneWithPreparing="doneWithPreparing"
                        @setFontSize="setFontSize"
                        :is-game-tuned="isGameTuned"
                        :font-size="fontSize"
                        :is-item-column-mode="true"
                        :amount-of-words="1"
                        element-name="catch-word__container_interactive-place_box"
                        :inverted-word="parameters && parameters.invertedWords"
                        :is-catch-word="true"
                    )
                    .catch-word__container_body(
                        :class="{'catch-word__container_body-top': parameters.mode === INTERACTIVE_MODE}",
                        v-else
                    )
                        .catch-word__container_interactive-place(
                            v-if="gameStarted && !gameFinished"
                            :class="{'catch-word__container_interactive-place__scrollable': readyToInput}"
                        )
                            .catch-word__container_interactive-place_box(
                                :class="{'catch-word__container_interactive-place_box-top': parameters.mode === INTERACTIVE_MODE}"
                            )
                                span.catch-word__container_interactive-place_box_item(
                                    v-if="displayingWord"
                                    :class="{\
                                        'catch-word__container_interactive-place_box_item--bold': parameters.mode !== INTERACTIVE_MODE,\
                                        'inverted-word': parameters.invertedWords\
                                    }"
                                    :style="[itemPosition, {'font-size': fontSize + 'px'}]"
                                    v-html="displayedItemText"
                                )
                                .catch-word__container_interactive-place_box_input(v-if="readyToInput")
                                    .catch-word__container_interactive-place_catch-word-text
                                        | {{ headerText }}
                                    cs-input.catch-word__container_input(
                                        v-if="parameters && !parameters.isSeries"
                                        ref="input"
                                        @keyup.native.enter="processReply"
                                        v-model="answer"
                                        v-focus="true"
                                    )
                                    .catch-word__container_inputs-block(v-else)
                                        .catch-word__container_inputs-block_container(
                                            v-for="(element, index) in seriesAnswers"
                                            :key="index"
                                        )
                                            span.catch-word__container_inputs-block_input-number
                                                | {{(index + 1) + "." }}
                                            cs-input.catch-word__container_input(
                                                @keyup.native.enter="processSeriesReply(index)"
                                                v-model="seriesAnswers[index]"
                                                ref="inputs"
                                                v-focus-on-first="index"
                                                :class="getInputClass(index)"
                                                :disabled="hasAnswered"
                                            )
                                            svg-icon.catch-word__container_icon(
                                                v-if="hasAnswered"
                                                :name="correctAnswersIndices.includes(index) ? 'check' : 'times'"
                                                size="x-large"
                                                :class="getIconClass(index)"
                                            )
                                    cs-button(
                                        color="blue"
                                        @click="parameters && (!parameters.isSeries && processReply() || processSeriesReply())"
                                        v-if="parameters && (parameters.isSeries && !hasAnswered || !parameters.isSeries)"
                                        :disabled="parameters && parameters.isSeries && seriesAnswers.some(answer => answer === '')"
                                    )
                                        |  {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                                    cs-button.continue-game-button(
                                        color="blue"
                                        v-if="parameters && parameters.isSeries && hasAnswered && !isOlympiad"
                                        @click="refreshGame"
                                        @keyup.enter="refreshGame"
                                    )
                                        | {{ $i18n.t('trainer.trainer_gamePlayBox_continue') }}
                        template(v-if="gameFinished && !isOlympiad")
                            .catch-word__container_result-container
                                fireworks
                                .catch-word__container_reaction
                                    .catch-word__container_reaction-side.catch-word__container_reaction-side_correct(
                                        v-if="parameters && parameters.mode === 'interactive'"
                                    )
                                        div
                                            | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                                        .catch-word__container_reaction-count
                                            | {{ answers.good }}
                                    .catch-word__container_reaction-image-container
                                        result-image.catch-word__container_reaction-image(status="success")
                                    .catch-word__container_reaction-side(v-if="parameters && parameters.mode === 'interactive'")
                                        div
                                            | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                                        .catch-word__container_reaction-count
                                            | {{ answers.bad }}
                                result-buttons(
                                    :exercise-id="exerciseId",
                                    :games-type="currentGamesType"
                                    show-restart-button
                                    @restartGame="restartGame"
                                )
                                    slot
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import _, { cloneDeep } from 'lodash';
    import CatchWordApi from '../../../../api/games/catchWord'
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import GamePreparationCounter from '../../GamePreparationCounter.vue'
    import GameInfo from '../GameInfo.vue'
    import ScalingBar from '../texts/ScalingBar.vue'

    const DEFAULT_VOLUME = 0.6;
    const INTERACTIVE_MODE = 'interactive';
    const MAX_WORD_LENGTH = 13;
    const MAX_SPAN_WIDTH = 1600;
    const MAX_SPAN_HEIGHT = 281;
    const SAME_UNICODE_SYMBOLS = ['Е', 'Ё'];

    function DEFAULT_DATA () {
        return {
            items: [],
            maxLength: 13,
            currentItemIndex: 0,
            displayingWord: false,
            firstTime: true,
            readyToInput: false,
            answer: "",
            seriesAnswers: [""],
            correctAnswer: "",
            seriesAmount: 0,
            hasAnswered: false,
            correctAnswersIndices: [],
            showWordTimeout: null,
            showWordsTimeout: null,
            answers: {
                good: 0,
                bad: 0
            },
            isGameTuned: false,
            fontSize: 32,
        }
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, olympiadAnswerTimerMixin],
        data () {
            return Object.assign({
                INTERACTIVE_MODE,
            }, DEFAULT_DATA())
        },
        components: {
            GamePreparationCounter,
            GameInfo,
            ScalingBar,
        },
        methods: {
            doneWithPreparing () {
                this.isGameTuned = true;
                this.isLoading = true;
                this.registerSounds();
            },
            setFontSize (fontSize) {
                this.fontSize = fontSize;
            },
            fetchData () {
                this.getExercise().then(() => {
                    if (this.exercise) {
                        this.answers.good = this.exercise.correctAnswers || 0;
                        this.answers.bad = this.exercise.wrongAnswers || 0;
                        if (this.parameters.mode !== INTERACTIVE_MODE || !this.parameters.isSeries) {
                            this.currentItemIndex = cloneDeep(this.exercise.correctAnswers);
                        } else {
                            this.seriesAmount = cloneDeep(this.exercise.correctAnswers);
                        }
                    }
                    if (this.parameters.viewType !== 'letters') {
                        CatchWordApi.getGameItems({
                            locale: this.user.locale,
                            type: this.parameters.viewType,
                            groups: this.parameters.selectedGroups,
                            amountOfWords: this.parameters.amountOfWords,
                            groupsLetters: this.parameters.lettersForGroups,
                            wordConstitutingLetters: this.parameters.wordConstitutingLetters
                        })
                        .then(data => {
                            this.items = Object.values(data.items);
                            if (this.parameters.lettersForGroups) {
                                const containsSameUnicodeSymbols = this.parameters.lettersForGroups.some(group => {
                                    return group.letters.some(letter => SAME_UNICODE_SYMBOLS.includes(letter));
                                });
                                if (containsSameUnicodeSymbols) {
                                    const lettersFromGroups = this.parameters.lettersForGroups.reduce((acc, item) => {
                                        return [...acc, ...item.letters];
                                    }, []).map(letter => letter.toUpperCase());
                                    this.items = this.items.filter(item => {
                                        return item.syllable.split('').every(letter => {
                                            return lettersFromGroups.includes(letter);
                                        })
                                    })
                                }
                                if (this.items.length < this.parameters.amountOfWords) {
                                    this.$toasted.info(
                                        this.parameters.viewType === 'words' ?
                                            this.$i18n.t('trainer.trainer_insufficientNumberOfWords'):
                                            this.$i18n.t('trainer.trainer_insufficientNumberOfSyllables'),
                                        { duration: 4500 }
                                    );
                                }
                                do {
                                    let arr = this.items;
                                    arr.forEach(item => {
                                        this.items.push(item);
                                    });
                                } while (this.items.length < this.parameters.amountOfWords);
                                this.items = _.take(this.items, this.parameters.amountOfWords);
                            }
                            this.maxLength = data.maxLength;
                            if (this.isWordsViewType && !this.parameters.accentedWords) {
                                this.items = this.items.map(word => {
                                    word.word = word.word.replace('&#x301;', '');
                                    return word;
                                });
                            }
                            this.isLoading = false;
                            if (this.isGameTuned) {
                                this.registerSounds();
                            }
                        })
                        .catch(e => this.showErrorMessage(e));
                    } else {
                        while (this.items.length !== this.parameters.amountOfWords) {
                            let amountOfNewItems = this.parameters.amountOfWords - this.items.length;
                            this.items.push(..._.take(_.shuffle(this.parameters.selectedGroups), amountOfNewItems));
                        }
                        this.items = this.items.map(item => {
                            return {letter: item}
                        });
                        this.maxLength = 1;
                        this.isLoading = false;
                        if (this.isGameTuned) {
                            this.registerSounds();
                        }
                    }
                }).catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                });
            },
            beforeStart () {
                if (!this.timer) {
                    this.setTimer();
                }
                this.gameStarted = true;
                if (this.parameters.isSeries && this.parameters.mode === INTERACTIVE_MODE) {
                    this.seriesAnswers = Array(this.parameters.amountOfWords).fill("");
                }
                if (this.firstTime) {
                    this.$nextTick(this.generateWordsPositions);
                }
                this.$nextTick(this.showWord);
            },
            showWord () {
                this.displayingWord = true;
                clearTimeout(this.showWordTimeout);
                this.showWordTimeout = setTimeout(() => {
                    if (this.parameters.mode !== INTERACTIVE_MODE) {
                        clearTimeout(this.showWordsTimeout);
                        this.showWordsTimeout = setTimeout(() => {
                            if (this.currentItemIndex < this.items.length - 1) {
                                this.currentItemIndex++;
                                this.$nextTick(this.showWord);
                            } else {
                                this.finishGame();
                            }
                        }, this.parameters.timeForAnswer * 1000);
                        if (this.answerDuration) {
                            this.startAnswerTimer();
                        }
                    } else {
                        if (!this.parameters.isSeries) {
                            this.readyToInput = true;
                            this.$refs.input && this.$nextTick(() => {
                                this.$refs.input.$el.focus();
                            });
                            if (this.answerDuration) {
                                this.startAnswerTimer();
                            }
                        } else {
                            if (this.currentItemIndex < this.items.length - 1) {
                                this.currentItemIndex++;
                                this.$nextTick(this.showWord);
                            } else {
                                this.readyToInput = true;
                                if (this.answerDuration) {
                                    this.startAnswerTimer();
                                }
                            }
                        }
                    }
                    this.displayingWord = false;
                }, this.parameters.showTime * 1000);
            },
            getNextWord () {
                if (this.currentItemIndex < this.items.length - 1) {
                    this.currentItemIndex++;
                    this.counter = 0;
                    this.gameStarted = false;
                    this.stopTimer();
                    this.timer = null;
                    this.runCounter();
                } else {
                    this.finishGame();
                }
            },
            generateWordsPositions () {
                let gameContainerWidth = document.querySelector('.play-box').clientWidth;
                let gameContainerHeight = document.querySelector('.play-box').clientHeight;
                let fontSize = this.parameters.mode === INTERACTIVE_MODE ? 103 : 174;
                let currentMaxSpanWidth = MAX_SPAN_WIDTH;
                let currentMaxSpanHeight = MAX_SPAN_HEIGHT;
                if (this.maxLength < MAX_WORD_LENGTH) {
                    currentMaxSpanWidth *= this.maxLength / MAX_WORD_LENGTH;
                }
                if (gameContainerWidth < currentMaxSpanWidth || gameContainerHeight < currentMaxSpanHeight) {
                    let coefficient = 1;
                    if (gameContainerWidth < currentMaxSpanWidth && gameContainerHeight < currentMaxSpanHeight) {
                        coefficient = Math.max((gameContainerWidth / currentMaxSpanWidth), (gameContainerHeight / currentMaxSpanHeight));
                    } else if (gameContainerWidth < currentMaxSpanWidth) {
                        coefficient = gameContainerWidth / currentMaxSpanWidth;
                    } else {
                        coefficient = gameContainerHeight / currentMaxSpanHeight;
                    }
                    let newFontSize = Math.ceil(coefficient * fontSize);
                    currentMaxSpanWidth = Math.ceil((currentMaxSpanWidth / fontSize) * newFontSize);
                    currentMaxSpanHeight = Math.ceil((currentMaxSpanHeight / fontSize) * newFontSize);
                    fontSize = newFontSize - 1;
                }
                let areaHeight = gameContainerHeight - currentMaxSpanHeight;
                this.items.forEach(item => {
                    if (this.parameters.wordsMovement) {
                        const x = Math.random() * (gameContainerWidth - currentMaxSpanWidth * (this.getItemLength(item) / this.maxLength));
                        const y = Math.random() * areaHeight;
                        item.x = x > 0 ? x : -x;
                        item.y = y > 0 ? y : -y;
                    }
                    item.fontSize = fontSize;
                });
                this.firstTime = false;
            },
            processSeriesReply (index) {
                if (index !== undefined && index !== this.items.length - 1 && this.$refs.inputs[index + 1]) {
                    this.$refs.inputs[index + 1].$el.focus();
                }
                if (this.seriesAnswers.every(answer => answer !== "")) {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    this.timer = null;
                    this.seriesAnswers = this.seriesAnswers.map(answer => this.formatItem(answer));
                    this.items.forEach(item => {
                        item.answer = this.formatItem(item);
                    });
                    if (this.areEqual(this.seriesAnswers, this.items)) {
                        this.answers.good++;
                        !this.isOlympiad && (this.soundInstance = this.$createjs.Sound.play('correct'));
                    } else {
                        this.answers.bad++;
                        !this.isOlympiad && (this.soundInstance = this.$createjs.Sound.play('incorrect'));
                    }
                    this.hasAnswered = true;
                    if (!this.isOlympiad) {
                        this.$nextTick(() => {
                            document.querySelector('.continue-game-button').focus();
                        });
                    } else {
                        this.refreshGame();
                    }
                } else if (this.isOlympiad) {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    this.timer = null;
                    this.answers.bad++;
                    this.refreshGame();
                }
            },
            areEqual (userWords, correctWords) {
                correctWords.forEach((item, index) => {
                    if (item.answer === userWords[index]) {
                        this.correctAnswersIndices.push(index);
                    }
                });
                return this.correctAnswersIndices.length === correctWords.length;
            },
            processReply () {
                if (this.isOlympiad && this.parameters.mode !== INTERACTIVE_MODE) {
                    this.getNextWord();
                    return;
                }
                if (this.isOlympiad && this.parameters.isSeries && this.parameters.mode === INTERACTIVE_MODE) {
                    this.processSeriesReply();
                    return;
                }
                if (this.answer !== '') {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    this.answer = this.formatItem(this.answer);
                    this.correctAnswer = this.getCorrectAnswer();
                    if (this.answer === this.correctAnswer)  {
                        this.answers.good++;
                        !this.isOlympiad && (this.soundInstance = this.$createjs.Sound.play('correct'));
                    } else {
                        this.answers.bad++;
                        if (!this.isOlympiad) {
                            this.soundInstance = this.$createjs.Sound.play('incorrect');
                            if (this.parameters.viewType !== 'letters') {
                                CatchWordApi.getGameItems({
                                    locale: this.user.locale,
                                    type: this.parameters.viewType,
                                    groups: this.parameters.selectedGroups,
                                    amountOfWords: 1
                                })
                                .then(data => {
                                    let item = Object.values(data.items)[0];
                                    this.maxLength = data.maxLength;
                                    this.isWordsViewType && !this.parameters.accentedWords
                                    && (item.word = item.word.replace('&#x301;', ''));
                                    this.items.push(item);
                                    this.firstTime = true;
                                    this.refreshGame();
                                })
                                .catch(e => this.showErrorMessage(e));
                            } else {
                                let item = {letter: _.take(_.shuffle(this.parameters.selectedGroups), 1)[0]};
                                this.maxLength = 1;
                                this.items.push(item);
                                this.firstTime = true;
                                this.refreshGame();
                            }
                            return;
                        }
                    }
                    this.refreshGame();
                } else if (this.isOlympiad) {
                    this.stopTimer();
                    this.stopAnswerTimer();
                    this.answers.bad++;
                    this.refreshGame();
                }
            },
            refreshGame () {
                this.readyToInput = false;
                this.answer = '';
                if (this.answerTimer) {
                    this.answerTime = 0;
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
                if (this.currentItemIndex < this.items.length - 1) {
                    this.sendStat();
                }
                if (this.parameters.isSeries && this.parameters.mode === INTERACTIVE_MODE) {
                    this.firstTime = true;
                    this.hasAnswered = false;
                    if (this.correctAnswersIndices.length === this.items.length || this.isOlympiad) {
                        ++this.seriesAmount;
                    }
                    if (this.seriesAmount < this.parameters.seriesAmount) {
                        this.currentItemIndex = 0;
                        this.correctAnswersIndices = [];
                        if (this.parameters.viewType !== 'letters') {
                            CatchWordApi.getGameItems({
                                locale: this.user.locale,
                                type: this.parameters.viewType,
                                groups: this.parameters.selectedGroups,
                                amountOfWords: this.parameters.amountOfWords
                            })
                            .then(data => {
                                this.items = Object.values(data.items);
                                this.maxLength = data.maxLength;
                                if (this.isWordsViewType && !this.parameters.accentedWords) {
                                    this.items = this.items.map(word => {
                                        word.word = word.word.replace('&#x301;', '');
                                        return word;
                                    });
                                }
                                this.$nextTick(this.beforeStart);
                            })
                            .catch(e => this.showErrorMessage(e));
                        } else {
                            this.items = [];
                            while (this.items.length !== this.parameters.amountOfWords) {
                                let amountOfNewItems = this.parameters.amountOfWords - this.items.length;
                                this.items.push(..._.take(_.shuffle(this.parameters.selectedGroups), amountOfNewItems));
                            }
                            this.items = this.items.map(item => {
                                return {letter: item}
                            });
                            this.maxLength = 1;
                            this.$nextTick(this.beforeStart);
                        }
                    } else {
                        this.finishGame();
                    }
                    return;
                }
                this.getNextWord();
            },
            finishGame () {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play("gameDone");
                }
                this.gameStarted = false;
                this.gameFinished = true;
                this.sendStat();
            },
            refreshGameStatBeforeSend () {
                this.gameStat.answers = this.parameters.mode === INTERACTIVE_MODE ? this.answers.good : this.currentItemIndex + 1;
                this.gameStat.attempts = this.parameters.mode === INTERACTIVE_MODE ? this.answers.bad + this.answers.good : this.currentItemIndex + 1;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.chainOfAttempts = [];
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.parameters.mode === INTERACTIVE_MODE ? this.calculatePercent() : 0;
                this.gameStat.amountOfWords = this.parameters.amountOfWords;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            calculatePercent () {
                let total = this.answers.good + this.answers.bad;

                if (total > 0) {
                    return parseInt(this.answers.good / (total) * 100);
                }
                return 0;
            },
            getInputClass (index) {
                if (this.hasAnswered) {
                    if (!this.correctAnswersIndices.includes(index)) {
                        return 'catch-word__container_input_incorrect';
                    }
                    return 'catch-word__container_input_correct';
                }
                return '';
            },
            getIconClass (index) {
                if (this.hasAnswered) {
                    return this.correctAnswersIndices.includes(index)
                            ? 'catch-word__container_icon_correct'
                            : 'catch-word__container_icon_incorrect'
                }
                return '';
            },
            getItemLength (item) {
                switch (this.parameters.viewType) {
                    case ('words'):
                        return item.word.replace('&#x301;', '').length;
                    case ('syllables'):
                        return item.syllable.length;
                    case ('letters'):
                        return item.letter.length;
                }
            },
            getCorrectAnswer () {
                switch (this.parameters.viewType) {
                    case ('words'):
                        return this.currentItem.word.toLowerCase()
                        .replace('&#x301;', '')
                        .replace(/ё/g, 'е').trim();
                    case ('syllables'):
                        return this.currentItem.syllable.toLowerCase().replace(/ё/g, 'е').trim();
                    case ('letters'):
                        return this.currentItem.letter.toLowerCase().trim();
                }
            },
            formatItem (item) {
                switch (this.parameters.viewType) {
                    case ('words'):
                        return item.word
                                ? item.word.toLowerCase()
                                .replace('&#x301;', '')
                                .replace(/ё/g, 'е').trim()
                                : item.toLowerCase()
                                .replace('&#x301;', '')
                                .replace(/ё/g, 'е').trim();
                    case ('syllables'):
                        return item.syllable
                                ? item.syllable.toLowerCase().replace(/ё/g, 'е').trim()
                                : item.toLowerCase().replace(/ё/g, 'е').trim();
                    case ('letters'):
                        return item.letter
                                ? item.letter.toLowerCase().trim()
                                : item.toLowerCase().trim();
                }
            },
            beforeGameRestart() {
                clearTimeout(this.showWordTimeout);
                clearTimeout(this.showWordsTimeout);
                Object.assign(this, DEFAULT_DATA());
            }
        },
        computed: {
            currentItem () {
                return this.items[this.currentItemIndex];
            },
            itemPosition () {
                if (this.parameters && this.parameters.wordsMovement) {
                    return {
                        position: 'absolute',
                        top: this.currentItem.y + 'px',
                        left: this.currentItem.x + 'px',
                        fontSize: this.currentItem.fontSize + 'px'
                    }
                }
                if (this.parameters.mode === 'interactive') {
                    return {'margin-top': '1rem', fontSize: this.currentItem.fontSize + 'px'};
                }
                return {'margin-top': '5rem', fontSize: this.currentItem.fontSize + 'px'};
            },
            headerText () {
                if (this.parameters.isSeries && !this.hasAnswered) {
                    switch (this.parameters.viewType) {
                        case ('words'):
                            return this.$i18n.t('trainer.trainer_gamePlayBox_catchTheWords');
                        case ('syllables'):
                            return this.$i18n.t('trainer.trainer_gamePlayBox_catchTheSyllables');
                        case ('letters'):
                            return this.$i18n.t('trainer.trainer_gamePlayBox_catchTheLetters');
                    }
                } else if (this.hasAnswered) {
                    return this.correctAnswersIndices.length === this.items.length
                            ? this.$i18n.t('trainer.trainer_gamePlayBox_wellDone')
                            : this.$i18n.t('trainer.trainer_gamePlayBox_tryAgain');
                }
                switch (this.parameters.viewType) {
                    case ('words'):
                        return this.$i18n.t('trainer.trainer_gamePlayBox_catchTheWord');
                    case ('syllables'):
                        return this.$i18n.t('trainer.trainer_gamePlayBox_catchTheSyllable');
                    case ('letters'):
                        return this.$i18n.t('trainer.trainer_gamePlayBox_catchTheLetter');
                }
            },
            displayedItemText () {
                switch (this.parameters.viewType) {
                    case ('words'):
                        return this.currentItem.word;
                    case ('syllables'):
                        return this.currentItem.syllable;
                    case ('letters'):
                        return this.currentItem.letter;
                }
            },
            isWordsViewType () {
                return this.parameters.viewType === 'words';
            },
            currentGamesType () {
                return this.type === 'CatchWordOnline' ? 'onlineSchool' : 'fastReading';
            }
        },
        beforeDestroy () {
            clearTimeout(this.showWordTimeout);
            clearTimeout(this.showWordsTimeout);
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .catch-word__container {
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        flex: 1 1 auto;
        @include inset-space($space-base);
        @include media($md) {
            flex-direction: row;
        }
    }

    .catch-word__container_with-content-at-top {
        align-items: start;
    }

    .catch-word__container_body {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        align-self: flex-start;
        width: 100%;
        height: 100%;
    }

    .catch-word__container_interactive-place {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        overflow: hidden;
    }

    .catch-word__container_interactive-place__scrollable {
        height: auto;
        overflow: visible;
    }

    .catch-word__container_interactive-place_box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;
        height: 100%;
    }

    .catch-word__container_interactive-place_box_item {
        background: $x-color-white;
        padding: 0 10px 10px;
        font-size: 32px;
        z-index: 1000;
        @include media ($sm) {
            font-size: 46px;
        }
        @include media ($md) {
            font-size: 54px;
            padding: 0 10px 20px;
        }
        @include media ($lg) {
            font-size: 84px;
        }
        @include media ($xlg) {
            font-size: 110px;
        }
        @include media ($xl) {
            font-size: 142px;
        }
        @include media ($xxl) {
            font-size: 182px;
        }
    }

    .catch-word__container_interactive-place_box_item--bold {
        font-weight: 500;
    }

    .catch-word__container_interactive-place_box_input {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .catch-word__container_interactive-place_catch-word-text {
        font-size: 22px;
        font-weight: 500;
        text-align: center;
        @include stack-space($space-base);
        @include media ($sm) {
            font-size: 28px;
        }
        @include media ($md) {
            font-size: 32px;
        }
    }

    .catch-word__container_input {
        font-size: 21px !important;
        width: 190px !important;
        height: 50px;
        margin-bottom: 20px !important;
        @include media ($sm) {
            font-size: 28px !important;
            width: 270px !important;
            height: 60px;
        }
        @include media ($lg) {
            font-size: 32px !important;
            width: 370px !important;
            height: 80px;
        }
        &:disabled {
            pointer-events: none;
            background-color: #f5f5f5;
            border-color: #f5f5f5;
            box-shadow: none;
        }
    }

    .catch-word__container_inputs-block {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .catch-word__container_inputs-block_container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .catch-word__container_input {
            margin: 0 !important;
        }
    }

    .catch-word__container_inputs-block_input-number {
        width: 36px;
        text-align: right;
        font-size: 22px;
        @include media ($sm) {
            font-size: 28px;
        }
        @include media ($md) {
            font-size: 32px;
        }
        @include inline-space($space-large);
        @media screen and (max-width: 640px) {
            @include inline-space($space-small);
        }
    }

    .catch-word__container_icon {
        margin: 0 $space-base;
        @media screen and (max-width: 640px) {
            margin-right: $space-x-small;
        }
    }

    .catch-word__container_result-container {
        display: flex;
        height: 100%;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .catch-word__container_icon_correct, .catch-word__container_input_correct {
        color: $hsl-color-green-48 !important;
    }

    .catch-word__container_icon_incorrect, .catch-word__container_input_incorrect {
        color: $hsl-color-red-62 !important;
    }

    .catch-word__container_reaction {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        @include stack-space($space-base);
        flex-direction: row;
        @include media($md) {
            flex-wrap: nowrap;
        }
        @media screen and (max-width: 655px) {
            justify-content: space-between;
        }
    }

    .catch-word__container_reaction-side {
        color: $hsl-color-red-62;
        font-size: 16px;
        @include media($sm) {
            font-size: 24px;
        }
        @include media($lg) {
            font-size: 38px;
        }
        align-self: normal;
        font-weight: 500;
        @include media($sm) {
            width: auto;
        }
        @include media($md) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            flex-grow: 1;
            align-self: flex-start;
        }
        @include stack-space($space-base);
        @include media($sm) {
            @include stack-space(0);
        }
        @media screen and (max-width: 768px) {
            width: 50%;
        }
        @include media ($lg) {
            align-self: center;
        }

        &:first-child {
            @media screen and (max-width: 767px) {
                order: 1;
            }
        }

        &:last-child {
            @media screen and (max-width: 767px) {
                order: 2
            }
        }
    }

    .catch-word__container_reaction-side_correct {
        color: $hsl-color-green-48
    }

    .catch-word__container_reaction-count {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .catch-word__container_reaction-image-container {
        @include stack-space($space-base);
        @media screen and (max-width: 767px) {
            order: 3;
            margin: 0 auto;
        }
    }

    .catch-word__container_reaction-image {
        @media screen and (max-width: 359px) {
            width: 100%;
        }
        @media screen and (min-width: 1300px) {
            margin: 0 30px;
        }
        @include media ($xl) {
            margin: 0 60px;
        }
    }

    .catch-word__container_body-top{
        justify-content: flex-start;
    }

    .catch-word__container_interactive-place_box-top {
        align-items: flex-start;
        margin-top: 1rem;
    }

    .result__link {
        @media screen and (max-width: 640px) {
            display: block;
            width: 100%;
            margin-bottom: 10px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .inverted-word {
        transform: rotate(180deg);
    }

    .game-info {
        align-self: flex-end;
        @include media ($md) {
            align-self: flex-start
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }
</style>
